export default __webpack_public_path__ + "static/media/bauhaus-feedback-2.ea14dac9.svg";